import React, { ReactNode, useMemo } from 'react';
import { EditItemProps, NewItemProps } from '../../toolympus/api/useNewItem';
import { Contact } from './types';
import { FormGrid, SimpleDialog } from '../../toolympus/components/primitives';
import { FieldType, Schema } from '../../toolympus/hooks/useSchema';
import { FieldDefinition, FormControlsForFields } from '../../toolympus/components/schemed';
import { PowerEditorBase } from '../../toolympus/components/PowerDoc';
import { ContactTagsPicker } from './ContactsTagsConfiguration';
import { useContactsSettings } from './useContactsSettings';
import { Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';

interface Props {
  data: NewItemProps<Partial<Contact>, Contact> | EditItemProps<Contact>;
  title: string;
  saveLabel?: ReactNode;
  schema: Schema;
  remove?: (c: Contact) => void;
}

export const ContactEditDialog = (props: Props) => {
  const { data, schema, title, saveLabel } = props;

  const { fields } = useContactsSettings();

  const attributes = useMemo(() => {
    const attributesSchema: Schema = {};
    const attributesFields: FieldDefinition[] = [];

    const sortedFields = [...fields].sort((a, b) => a.sortorder - b.sortorder);

    sortedFields.forEach(field => {
      if (field.is_enabled) {
        attributesSchema[field.key] = {
          type: FieldType.textlong,
          label: field.title
        };

        attributesFields.push([field.key]);
      }
    });

    return { attributesSchema, attributesFields };
  }, [fields]);

  return (
    <SimpleDialog
      dialogTitle={title}
      saveLabel={saveLabel || "сохранить"}
      noFullscreen
      save={() => data.save()}
      isOpen={data.isEditing}
      close={data.cancel}
      submitOnModEnter
      simpleExtraActions={<>
        {!!data.item?._id && !!props.remove &&
          <Button onClick={() => props.remove && props.remove(data.item as any)}>
            <FormattedMessage id="common.delete" />
          </Button>}
      </>}
      >
        {!!data.item &&
          <>
            <FormGrid columns="1fr 1fr" forceEvenColumns suppressContentColumnsOnSm>
              <FormControlsForFields
                fields={[
                  ["name", { controlProps: { autoFocus: true }, wrapperStyle: { gridColumn: "span 2"} }],
                  ["proximity"],
                  ["birth_date"],
                  ["phone"],
                  ["email"],
                ]}
                schema={schema}
                data={data.item}
                onChange={(o,c) => data.update(c)}
                />
            </FormGrid>

            <FormGrid columns="1fr">
              <FormControlsForFields
                fields={attributes.attributesFields}
                schema={attributes.attributesSchema}
                data={data.item}
                onChange={(o,c) => data.update(c)}
                />

              <ContactTagsPicker
                tags={data.item.tags}
                update={v => data.update({ tags: v })}
                />

              <PowerEditorBase
                key={data.item._id}
                content={data.item.notes}
                update={(v => data.update({ notes: v }))}
                />
            </FormGrid>
          </>}
    </SimpleDialog>
  );
}
